import { Box, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { getColor } from "../style/color/color";
import { fonts } from "../style/fonts/fonts";
export const PlusMinusButton = ({ childCards, onClickAdd, onClickRemove }) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: 163,
      height: 40,
      background: "#C2E0F9",
      borderRadius: 1,
      marginTop: "4px",
    }}
  >
    <RemoveIcon
      sx={{
        color: getColor.SecondarySummerSky,
        fontSize: 24,
        fontFamily: fonts.manrope,
        fontWeight: 700,
        lineHeight: "48px",
        cursor: "pointer",
      }}
      onClick={onClickRemove}
    />
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: 82,
        height: 40,
        background: "#EBF5FD",
        borderRadius: 1,
        mx: 1,
      }}
    >
      <Typography>{childCards}</Typography>
    </Box>
    <AddIcon
      sx={{
        color: getColor.SecondarySummerSky,
        fontSize: 24,
        fontFamily: fonts.manrope,
        fontWeight: 700,
        lineHeight: "48px",
        cursor: "pointer",
      }}
      onClick={onClickAdd}
    />
  </Box>
);
